export function eskadrilaAccordion() {
	// Handle accordion clicks
	$(".acc-trigger").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation(); // Prevent event from bubbling to document

		const $parent = $(this).closest(".eskadrila-accordion");
		const $wrapper = $(this).closest(".eskadrila-accordion-container");
		const $panel = $wrapper.find(".acc-panel");

		// If parent has data-collapse-all attribute, close all other accordions first
		if ($parent.attr("data-collapse-all") !== undefined) {
			$parent
				.find(".eskadrila-accordion-container.open")
				.not($wrapper)
				.each(function () {
					const $otherPanel = $(this).find(".acc-panel");
					$otherPanel.stop().animate({ height: 0 }, 250, function () {
						$(this)
							.closest(".eskadrila-accordion-container")
							.removeClass("open");
						$(this).attr("aria-hidden", "true").css("height", 0);
						$(this)
							.closest(".eskadrila-accordion-container")
							.find(".acc-trigger")
							.attr("aria-expanded", "false");
					});
				});
		}

		// Expand or collapse the current accordion
		if ($wrapper.hasClass("open")) {
			/* collapse */
			$panel.stop().animate({ height: 0 }, 250, function () {
				$wrapper.removeClass("open");
				$panel.attr("aria-hidden", "true").css("height", 0);
				$(e.currentTarget).attr("aria-expanded", "false");
			});
		} else {
			/* expand */
			$panel.css("height", "auto"); // let browser calc true height
			const fullHeight = $panel.height(); // store it
			$panel.height(0); // reset to 0 so we can animate
			$panel.stop().animate({ height: fullHeight }, 250, function () {
				$panel.css("height", "auto"); // allow flexible content later
			});

			$wrapper.addClass("open");
			$panel.attr("aria-hidden", "false");
			$(e.currentTarget).attr("aria-expanded", "true");
		}
	});

	// Close all accordions when clicking outside
	$(document).on("click", function (e) {
		if (!$(e.target).closest(".eskadrila-accordion").length) {
			$(".eskadrila-accordion-container.open").each(function () {
				const $wrapper = $(this);
				const $panel = $wrapper.find(".acc-panel");
				const $trigger = $wrapper.find(".acc-trigger");

				$panel.stop().animate({ height: 0 }, 250, function () {
					$wrapper.removeClass("open");
					$panel.attr("aria-hidden", "true").css("height", 0);
					$trigger.attr("aria-expanded", "false");
				});
			});
		}
	});
}
